import {Dropdown, Menu} from 'acud';

export default function SwitchLang() {
    const handleClick = () => (window.location.href = '/?lang=en');
    const menu = (
        <Menu style={{width: 100}} mode="vertical">
            <Menu.Item key="en" onClick={handleClick}>
                英文
            </Menu.Item>
        </Menu>
    );
    return (
        <>
            <Dropdown
                label={'语言'}
                labelIcon
                overlay={menu}
            />
        </>
    );
}
